export enum AmountType {
    PERCENT = "percent",
    ABSOLUTE = "absolute",
}

export enum VariableAmountType {
    VARIABLE = "variable",
}
